import type { AssetStatus } from '@/enum/AssetStatus'
import type { OwnershipType } from '@/enum/OwnershipType'
import type { IDimensionSpecifications, IVehicle } from '@/interfaces'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'
import type { IEngineSpecifications } from '@/interfaces/IEngineSpecifications'
import type { IFuelEconomySpecifications } from '@/interfaces/IFuelEconomySpecifications'
import type { IWheelsAndTiresSpecifications } from '@/interfaces/IWheelsAndTiresSpecifications'
import WheelsAndTiresSpecifications from '@/models/WheelsAndTiresSpecifications'
import { DimensionSpecifications } from '@/models'
import Base from '@/models/Base'
import EngineSpecifications from '@/models/EngineSpecifications'
import FuelEconomySpecifications from '@/models/FuelEconomySpecifications'
import DecimalValueAndUnit from '../DecimalValueAndUnit'

class Vehicle extends Base implements IVehicle {
  title: string
  avatarUrl: string
  registration: string
  make: string
  model: string
  year: number
  type: string
  status: AssetStatus
  odometerReading: IDecimalValueAndUnit
  machineHours: number
  ownership: OwnershipType
  fitnessValidUpto: string
  commissionDate: string
  decommissionDate: string
  dimensionSpecifications: IDimensionSpecifications
  engineSpecifications: IEngineSpecifications
  fuelEconomySpecifications: IFuelEconomySpecifications
  wheelsAndTiresSpecifications: IWheelsAndTiresSpecifications

  constructor(vehicle?: any) {
    super(vehicle)
    this.title = vehicle?.title
    this.avatarUrl = vehicle?.avatarUrl
    this.registration = vehicle?.registration
    this.make = vehicle?.make
    this.model = vehicle?.model
    this.year = vehicle?.year
    this.type = vehicle?.type
    this.status = vehicle?.status
    this.odometerReading = new DecimalValueAndUnit(vehicle?.odometerReading)
    this.machineHours = vehicle?.machineHours
    this.ownership = vehicle?.ownership
    this.fitnessValidUpto = vehicle?.fitnessValidUpto
    this.commissionDate = vehicle?.commissionDate
    this.decommissionDate = vehicle?.decommissionDate
    this.dimensionSpecifications = new DimensionSpecifications(vehicle?.dimensionSpecifications)
    this.engineSpecifications = new EngineSpecifications(vehicle?.engineSpecifications)
    this.fuelEconomySpecifications = new FuelEconomySpecifications(
      vehicle?.fuelEconomySpecifications
    )
    this.wheelsAndTiresSpecifications = new WheelsAndTiresSpecifications(
      vehicle?.wheelsAndTiresSpecifications
    )
  }
}

export default Vehicle
